import cacheMetrics from '../utils/cacheMetrics';

class MenuCacheService {
  constructor() {
    this.clearLegacyCache();
  }

  async getWithCache(key, fetchFn) {
    const startTime = Date.now();

    try {
      const data = await fetchFn();
      cacheMetrics.trackCacheMiss(key, 'cache_disabled');
      cacheMetrics.trackApiRequest(key, Date.now() - startTime, false);
      return data;
    } catch (error) {
      console.error(`Error fetching data for key ${key}:`, error);
      throw error;
    }
  }

  clearLegacyCache() {
    try {
      if (typeof window !== 'undefined') {
        Object.keys(window.localStorage).forEach((key) => {
          if (key.startsWith('syrve_menu_')) {
            window.localStorage.removeItem(key);
          }
        });
      }
    } catch (error) {
      console.warn('Could not remove legacy local menu cache:', error);
    }

    try {
      if (typeof indexedDB !== 'undefined') {
        const request = indexedDB.deleteDatabase('MenuCacheDB');
        request.onerror = () => {
          console.warn('Could not remove legacy IndexedDB menu cache:', request.error);
        };
      }
    } catch (error) {
      console.warn('Could not remove legacy IndexedDB menu cache:', error);
    }
  }

  async clearCache() {
    this.clearLegacyCache();
  }

  async invalidatePattern() {
    this.clearLegacyCache();
  }

  generateCacheKey(prefix, ...params) {
    return `${prefix}:${params.filter(Boolean).join(':')}`;
  }


  getCacheStats() {
    return {
      memoryCacheSize: 0,
      pendingRequests: 0,
      cacheKeys: [],
      metrics: cacheMetrics.getMetricsSummary()
    };
  }

  logMetrics() {
    cacheMetrics.logSummaryToConsole();
  }
}

const menuCacheService = new MenuCacheService();

if (process.env.NODE_ENV === 'development') {
  window.menuCacheService = menuCacheService;
  window.cacheMetrics = cacheMetrics;
  console.log('📊 Request metrics available: window.menuCacheService.logMetrics()');
}

export default menuCacheService;
